import Vue from 'vue';
import firebase from 'firebase/app';
import 'firebase/auth';

const state = {
  user: null
};

const getters = {
  user: state => {
    return state.user;
  }
};

// Career section
const mutations = {
  signout(state, payload) {
    state.user = null;
  },

  signin(state, payload) {
    state.user = payload;
  }
};

// Career section

const actions = {
  signout({ commit }) {
    firebase
      .auth()
      .signOut()
      .then(function() {
        // Sign-out successful.
        commit('signout', null);
      })
      .catch(function(error) {
        // An error happened.
      });
  },

  signin({ commit, dispatch }, payload) {
    firebase
      .auth()
      .signInWithEmailAndPassword(payload.email, payload.password)
      .then(user => {
        commit('showMessage', {
          type: 'info',
          message: 'Signed in, Welcome!'
        });

        commit('signin', user);
        dispatch('load');
      })
      .catch(error => {
        if (error) {
          commit('showMessage', {
            type: 'error',
            message: 'Error: Login failed, please try again!'
          });
          console.log(error);
        }
      });
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/user.js